import { useState, useEffect, useRef } from "react";

interface CustomSelectProps {
  data: any[];
  value: string;
  onChange: (val: string) => void;
  labelKey?: string;      // field for display text
  valueKey?: string;      // field for value
  imageKey?: string;      // optional field for image
  placeholder?: string;
}

const CustomSelect = ({
  data = [],
  value,
  onChange,
  labelKey = "name",
  valueKey = "_id",
  imageKey,
  placeholder = "Select an option"
}: CustomSelectProps) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selected = data?.find((item) => item[valueKey] === value);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ position: "relative" }} ref={wrapperRef}>
      {/* Selected box */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          border: "1px solid #e0e0e0",
          padding: "10px",
          borderRadius: "8px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#fafbfc",
        }}
      >
        {selected ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {imageKey && selected[imageKey] && (
              <img
                // className="img-fluid h-10 w-10 rounded-full border object-cover"
                className="img-fluid h-5 w-8  border object-cover"

                src={selected[imageKey]}
                alt="option"
                style={{
                  // width: 20,
                  // height: 20,
                  // borderRadius: "50%",
                  marginRight: 10,
                  border: "1px solid #e0e0e0",
                }}
              />
            )}
            {selected[labelKey]}
          </div>
        ) : (
          placeholder
        )}
        <span
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            display: "inline-block",
          }}
        >
          {"\u25BC"}
        </span>
      </div>

      {/* Dropdown list */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fafbfc",
            border: "1px solid #e0e0e0",
            zIndex: 10,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {data.map((item) => (
            <div
              key={item[valueKey]}
              onClick={() => {
                onChange(item[valueKey]);
                setOpen(false);
              }}
              style={{
                padding: "10px",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {imageKey && item[imageKey] && (
                <img 
                // className="img-fluid h-10 w-10 rounded-full border object-cover"
                className="img-fluid h-5 w-8  border object-cover"

                  src={item[imageKey]}
                  alt="option"
                  style={{
                    // width: 20,
                    // height: 20,
                    // borderRadius: "50%",
                    marginRight: 10,
                    border: "1px solid #e0e0e0",
                  }}
                />
              )}
              {item[labelKey]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
